import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { PpaScenarioActionType } from 'types/ppa';

type CreateScenarioFooterProps = {
    projectId: number;
    isScenarioLimitReached: boolean;
    childLimit?: number;
    onCreateScenario: (projectId: number, actionType: PpaScenarioActionType) => void;
};

const CreateScenarioFooter = ({
    projectId,
    isScenarioLimitReached,
    childLimit,
    onCreateScenario,
}: CreateScenarioFooterProps) => (
    <div className="h-[42px] flex items-center px-4 border-b border-[#F0F0F0] bg-[#FBFAFF]">
        <button
            type="button"
            className={`bg-transparent border-0 text-[14px] leading-[22px] px-0 ${
                isScenarioLimitReached
                    ? 'text-[#A1A1AA] cursor-not-allowed'
                    : 'text-purpleFont cursor-pointer'
            }`}
            disabled={isScenarioLimitReached}
            onClick={() => onCreateScenario(projectId, PpaScenarioActionType.Create)}
        >
            + Create New Scenario
        </button>
        {isScenarioLimitReached && typeof childLimit === 'number' ? (
            <Tooltip
                color="black"
                title={`You can only create ${childLimit} scenarios`}
                placement="top"
                trigger="hover"
            >
                <InfoCircleOutlined
                    className="ml-2 !text-[#FAAD14]"
                    style={{ cursor: 'pointer', position: 'relative' }}
                />
            </Tooltip>
        ) : null}
    </div>
);

export default CreateScenarioFooter;
